// app/javascript/members.js

export function initMembers() {
  const form = document.getElementById("memberForm");
  if (!form) return; // ✅ Only run if memberForm is present

  // 1. Intercept offcanvas open events to hydrate field contents
  const offcanvasElement = document.getElementById("dokMemberFormModal");
  if (offcanvasElement) {
    offcanvasElement.addEventListener("show.bs.offcanvas", function (event) {
      const button = event.relatedTarget;
      if (!button) return; // Safeguard if triggered programmatically

      const action = button.getAttribute("data-action");

      if (action === "edit") {
        form.dataset.memberId = button.getAttribute("data-member-id");
        
        // Pre-fill input value structures using standard DOM row attributes
        document.getElementById("member_name").value = button.getAttribute("data-member-name") || "";
        document.getElementById("member_phone").value = button.getAttribute("data-member-phone") || "";
        document.getElementById("member_email").value = button.getAttribute("data-member-email") || "";
        document.getElementById("member_role").value = button.getAttribute("data-member-role") || "member";
        document.getElementById("member_group_id").value = button.getAttribute("data-member-group-id") || "";
        document.getElementById("member_leadership_role_id").value = button.getAttribute("data-member-leadership-role-id") || "";
      } else {
        form.dataset.memberId = "";
        form.reset();
      }
    });
  }

  // 2. Process Asynchronous Form Submission Mutations
  const saveBtn = document.getElementById("saveMemberBtn");
  if (saveBtn) {
    saveBtn.onclick = function () {
      const memberId = form.dataset.memberId;
      
      // Compute explicit target paths and RESTful routing methods dynamically
      const url = memberId ? `/members/${memberId}` : "/members";
      const method = memberId ? "PATCH" : "POST";

      // Build pure member tracking payload data (Zero trace of passwords)
      const payload = {
        name: document.getElementById("member_name").value,
        phone_number: document.getElementById("member_phone").value,
        email: document.getElementById("member_email").value,
        role: document.getElementById("member_role").value,
        target_group_id: document.getElementById("member_group_id").value,
        target_leadership_role_id: document.getElementById("member_leadership_role_id").value
      };

      fetch(url, {
        method: method,
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content
        },
        body: JSON.stringify({ account: payload })
      })
        .then(response => response.json())
        .then(data => {
          if (data.success) {
            window.location.reload(); // Hard reloads on success to update table rows (Turbo-Free)
          } else {
            if (data.errors && Array.isArray(data.errors)) {
              alert(data.errors.join(", "));
            } else {
              alert(data.error || "An error occurred during account mutations");
            }
          }
        })
        .catch(error => {
          console.error("Communication failure:", error);
          alert("Network error processing transaction entry");
        });
    };
  }
}

// Global safety initializer block
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initMembers);
} else {
  initMembers();
}
